<template>
	<div class="projectAbandon" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 项目任务 / 作废项目</span>
		</div>
		<div class="content_Box box-shadow m-t-15" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<template class="">
				<el-table :data="projectArr" stripe style="width: 100%">
					<el-table-column label="项目编号" width="160px">
						<template slot-scope="{row,$index}">
							<span class=" font-Tahoma ">{{row.project_sn}}</span>
						</template>
					</el-table-column>
					<el-table-column label="项目名称" min-width="120px" :show-overflow-tooltip="true">
						<template slot-scope="{row,$index}">
							<span @click="gotToDetail(row)" style="color: var(--theme-purple)" class="cursor-pointer font-underline">{{row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="订单" align="right" width="100px">
						<template slot-scope="{row,$index}">
							<span class="cursor-pointer font-underline font-Impact text-color-blue" @click="goToOrderList(row)">{{row.totality}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="settlement_money" align="right" label="项目金额" width="120px">
						<template slot-scope="{row,$index}">
							<p class="font-consolas">{{row.settlement_money | filterNumber}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="状态" align="center" width="120px">
						<template slot-scope="{row,$index}">
							<span class="xm-state-8" v-if="row.status=='8'">已作废</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="项目时间" width="170px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.start_time}} ~ {{row.end_time}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bank_card" label="省份城市" width="170px">
						<template slot-scope="{row,$index}">
							<span>{{row.district}} - {{row.city}}</span>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" width="170px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.add_time}}</span>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		mainfun
	} from '../assets/js/main.js';
	export default {
		name: 'projectAbandon',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				projectArr: [], // 项目集合、
				token: window.sessionStorage.getItem('token'),
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100], //每页展示条数
				pageSizeNow: 20, //当前每页多少行

			}
		},
		created() {
			if (!sessionStorage.getItem('userInfo')) { //判断是否登录
				window.location = 'login.html';
				return;
			}
			let pagingArr = JSON.parse(sessionStorage.getItem('pagingArr')); //分页存储
			if (pagingArr) {
				let paging = pagingArr.filter((val) => {
					return val.name == 'projectAbandon'
				})
				paging = paging[0]
				if (paging) {
					this.pageNum = paging.pageNum;
					this.pageSizeNow = paging.pageSizeNow;
					this.getProjectList(this.pageNum, this.pageSizeNow);
					sessionStorage.removeItem('pagingArr'); //清除分页存储 
				} else {
					this.getProjectList(this.pageNum, this.pageSizeNow);
				}
			} else {
				this.getProjectList(this.pageNum, this.pageSizeNow);
			};
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {

			},
			
			getProjectList() { //获取项目列表
				let fn = new FormData();
				fn.append('page', arguments[0]); //文件
				fn.append('page_size', arguments[1]); //文件
				this.$http.post(this.url + '/zhongfy/company/RecyclingList', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						let data = res.data.data;
						this.projectArr = res.data.data.list
						this.total = res.data.data.total
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			gotToDetail(row) {
				let pagingArr = [];
				let paging = {
					name: 'projectAbandon',
					pageNum: this.pageNum,
					pageSizeNow: this.pageSizeNow,
				};
				pagingArr.push(paging);
				sessionStorage.setItem('pagingArr', JSON.stringify(pagingArr)); //分页

				this.$router.push({
					path: '/projectNewDetail',
					query: {
						id: row.id
					}
				})
			},
			goToOrderList(row) {
				this.$router.push({
					path: '/orderList',
					query: {
						id: row.id
					}
				})
			},

			// 分页
			handleCurrentChange(val) { //切换页数
				this.pageNum = val;
				this.getProjectList(this.pageNum, this.pageSizeNow);
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1;
				this.getProjectList(this.pageNum, this.pageSizeNow);
			},
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.projectAbandon {}

	.demo-table-expand {
		font-size: 0;
		background: #f5f6fa;
		border: 1px solid #EBEEF5;
		padding: 15px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/ProjectAbandon.vue